import { useState } from "react";

interface TooltipProps {
  text: string;
  children: React.ReactNode;
  position?: "above" | "below";
}

export function InfoTip({ text, children, position = "above" }: TooltipProps) {
  const [show, setShow] = useState(false);

  const posClass = position === "below"
    ? "top-full mt-1.5"
    : "bottom-full mb-1.5";

  return (
    <span
      className="relative inline-flex items-center gap-1"
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {children}
      <span className="text-text-secondary cursor-help text-[15px] leading-none select-none animate-pulse">ⓘ</span>
      {show && (
        <span className={`absolute left-1/2 -translate-x-1/2 ${posClass} px-2.5 py-1.5 rounded-md bg-surface-700 border border-surface-600 text-[15px] text-text-secondary leading-snug whitespace-normal w-56 z-[100] shadow-lg pointer-events-none font-normal not-italic tracking-normal`}>
          {text}
        </span>
      )}
    </span>
  );
}
